<div class="profile-icon__wrapper">
    <div class="profile-icon__initials">
        {{ initials }}
    </div>
</div>
